import $ from '../../shared/dom.js';
import { nextTick } from '../../shared/utils.js';

export default function slideToClickedSlide() {
  const swiper = this;
  const { params, $wrapperEl } = swiper;

  const slidesPerView =
    params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToindex = swiper.clickedindex;
  let realindex;
  if (params.loop) {
    if (swiper.animating) return;
    realindex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    if (params.centeredSlides) {
      if (
        slideToindex < swiper.loopedSlides - slidesPerView / 2 ||
        slideToindex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2
      ) {
        swiper.loopFix();
        slideToindex = $wrapperEl
          .children(
            `.${params.slideClass}[data-swiper-slide-index="${realindex}"]:not(.${params.slideDuplicateClass})`,
          )
          .eq(0)
          .index();

        nextTick(() => {
          swiper.slideTo(slideToindex);
        });
      } else {
        swiper.slideTo(slideToindex);
      }
    } else if (slideToindex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToindex = $wrapperEl
        .children(
          `.${params.slideClass}[data-swiper-slide-index="${realindex}"]:not(.${params.slideDuplicateClass})`,
        )
        .eq(0)
        .index();

      nextTick(() => {
        swiper.slideTo(slideToindex);
      });
    } else {
      swiper.slideTo(slideToindex);
    }
  } else {
    swiper.slideTo(slideToindex);
  }
}
